module.exports = __webpack_public_path__ + "static/media/Logo_SAS-LOG-01.c3a59edb.png";